document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.featured-product');

  if (!section) return;

  const variantCards = section.querySelectorAll(
    '.featured-product__variant-card'
  );

  const variantIdInput = section.querySelector(
    '.featured-product__variant-id'
  );

  /**
   * Variant Selection
   */
  variantCards.forEach((card) => {
    card.addEventListener('click', () => {
      const variantId = card.dataset.variantId;

      variantCards.forEach((item) => {
        item.classList.remove('is-active');

        const radio = item.querySelector(
          'input[type="radio"]'
        );

        if (radio) {
          radio.checked = false;
        }
      });

      card.classList.add('is-active');

      const radio = card.querySelector(
        'input[type="radio"]'
      );

      if (radio) {
        radio.checked = true;
      }

      if (variantIdInput) {
        variantIdInput.value = variantId;
      }
    });
  });

  /**
   * Quantity Selector
   */
  const qtyInput = section.querySelector(
    '.featured-product__qty-input'
  );

  const minusBtn = section.querySelector(
    '.featured-product__qty-minus'
  );

  const plusBtn = section.querySelector(
    '.featured-product__qty-plus'
  );

  if (minusBtn && qtyInput) {
    minusBtn.addEventListener('click', () => {
      let currentQty = parseInt(qtyInput.value, 10) || 1;

      currentQty = Math.max(1, currentQty - 1);

      qtyInput.value = currentQty;
    });
  }

  if (plusBtn && qtyInput) {
    plusBtn.addEventListener('click', () => {
      let currentQty = parseInt(qtyInput.value, 10) || 1;

      qtyInput.value = currentQty + 1;
    });
  }

  /**
   * Prevent invalid values
   */
  if (qtyInput) {
    qtyInput.addEventListener('change', () => {
      let value = parseInt(qtyInput.value, 10);

      if (isNaN(value) || value < 1) {
        qtyInput.value = 1;
      }
    });
  }
});